"use strict";

const modalWrapper = document.getElementById("modal-wrapper");
const horizontalScrollHint = document.getElementById("horizontal-scroll-hint");

// モーダルでポップアップ表示するための関数
function showModal() {
  modalSizeAdjustment();
  window.addEventListener("resize", modalSizeAdjustment);
  modalWrapper.classList.add("visible");
}

// モーダルを非表示にするための関数
function hideModal() {
  modalWrapper.classList.remove("visible");
  modalWrapper.classList.remove("hidden");
}

// モーダルのサイズ調整関数
function modalSizeAdjustment() {
  const entranceElement = modalWrapper.querySelector(".entrance");
  const entranceBgElement = modalWrapper.querySelector(".entrance-bg");
  const entranceHeadElement = modalWrapper.querySelector(".entrance-bg-head");
  entranceElement.style.marginTop = `${entranceHeadElement.clientHeight}px`;
  entranceElement.style.height = `${entranceBgElement.clientHeight - entranceHeadElement.clientHeight}px`;
}

// 初回訪問かチェックする関数
function checkFirstVisit() {
  return sessionStorage.getItem("isFirstVisited") === null;
}

// クリックされた時の処理を設定する関数
function setupButtonClick() {
  // 全ての対象ボタンにイベントを追加
  const buttons = document.querySelectorAll(".modal-ok-button, #close-modal-contents");
  buttons.forEach(function (button) {
    button.addEventListener("click", function () {
      sessionStorage.setItem("isFirstVisited", true);
      hideModal();
      setupHorizontalScrollHint();
    });
  });
}

// スクロールヒント向けの処理を設定する関数
function setupHorizontalScrollHint() {
  if (horizontalScrollHint) {
    const container = document.querySelector(".categories");
    horizontalScrollHint.classList.add("visible");

    // スクロールヒントが表示されたら、スクロールイベントを監視
    const scrollHandler = function () {
      horizontalScrollHint.classList.remove("visible");
      container.removeEventListener("wheel", scrollHandler);
      container.removeEventListener("touchmove", scrollHandler);
    };

    // 初期読み込み時にスクロールする経路があるため 'scroll' は利用できない
    container.addEventListener("wheel", scrollHandler);
    container.addEventListener("touchmove", scrollHandler);

    // 10秒で非表示にする
    setTimeout(() => scrollHandler(), 10000);
  }
}

// ページの読み込みが完了した時に実行する処理
window.addEventListener("load", function () {
  if (!modalWrapper) {
    setTimeout(() => setupHorizontalScrollHint(), 1000);
    return;
  }

  // モーダルでポップアップ表示
  if (checkFirstVisit()) {
    showModal();
  } else {
    hideModal();
    setTimeout(() => setupHorizontalScrollHint(), 1000);
  }

  setupButtonClick();
});
